import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://078b7946288228e10a8b6f83f1b58b14@o4508689871405056.ingest.us.sentry.io/4509222714015744",  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance and error monitoring
  tracesSampleRate: 0.05,
  // Set tracePropagationTargets to your actual API domains for production
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/hi.initia-digital\.co\.nz/,
    /^https:\/\/sandpit\.hi\.initia-digital\.co\.nz/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  // Environment and release tracking
  environment: import.meta.env.VITE_ENV_LOWER || 'development',
  release: process.env.PACKAGE_VERSION
});


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
